import { ApiCoupon } from '@/models/api/coupon'
import { MutationTree } from 'vuex'

import { log } from '../../../log'
import { CouponState } from './types'

const namespace = 'coupon'

export const mutations: MutationTree<CouponState> = {

  list(state, coupons: ApiCoupon[]) {
    state.coupons = coupons
    log.debug({ commit: `${ namespace }/list`, state })
  },
  inputCouponCode(state, couponCode: string) {
    state.couponCode.inputtingText = couponCode
    log.debug({ commit: `${ namespace }/inputCouponCode`, state })
  },
  errorOnLoad(state, error: Error) {
    state.loadError = error
    log.debug({ commit: `${ namespace }/errorOnLoad`, state })
  },
}
